/**
 * Post message to iframe on window resize
 * so correct video size can be picked
 *
 * @param {HTMLIFrameElement} iframe
 * @returns {void}
 */
export default function notifyResize(iframe) {
  iframe.contentWindow.postMessage(
    {
      type: "speakeasy:parent:resize",
      height: Math.max(
        document.documentElement.clientHeight || 0,
        window.clientHeight || 0
      ),
      width: Math.max(
        document.documentElement.clientWidth || 0,
        window.clientWidth || 0
      )
    },
    "*"
  );
}
